import axios from "axios";
import { useContext, useRef } from "react";
import { Link } from "react-router-dom";
import { Context } from "../../context/Context";
import "./Login.css";

const Login = () => {
  const userRef = useRef();
  const passwordRef = useRef();
  const { dispatch, isFetching } = useContext(Context);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_START" });
    try {
      const res = await axios.post("/Authentication/login", {
        username: userRef.current.value,
        password: passwordRef.current.value,
      });
      dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
    } catch (err) {
      dispatch({ type: "LOGIN_FAILURE" });
    }
  };

  return (
    <div className="login">
      <span className="login_title">Login</span>
      <form className="login_form" onSubmit={handleSubmit}>
        <label htmlFor="username">Username: </label>
        <input
          type="text"
          className="login_input"
          placeholder="Enter your username"
          ref={userRef}
        />
        <label htmlFor="password">Password: </label>
        <input
          type="password"
          className="login_input"
          placeholder="Enter your password"
          ref={passwordRef}
        />
        <button className="login_button" type="submit" disabled={isFetching}>
          Log In
        </button>
      </form>

      <Link to="/register">
        <button className="login_register_button">Register</button>
      </Link>
    </div>
  );
};

export default Login;
